import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import OneAsyncSelectToRuleThemAll from "../../../shared/components/one_async_select_to_rule_them_all.jsx";

class SearchInsuredBuildingsField extends React.Component {
  constructor(props) {
    super(props);

    this.state = { 
      value: null,
      loadedOptions: []
    }
  }

  getVehicles = (input) => {
    return fetch(`${this.props.loadPath}&description=${input || ""}`, {
      credentials: "same-origin",
    })
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        const transformedOptions = json.map(item => ({
          value: item.fake_id,
          label: item.select_label,
          originalData: item
        }));
        this.setState({ loadedOptions: transformedOptions });
        return transformedOptions;
      });
  };

  onChange = (option) => {
    this.setState({ value: option }, () => { this.props.onChange(option ? option.originalData : null); })
  };

  render() {
    return (
      <OneAsyncSelectToRuleThemAll.Base
        labelText="Search for Building"
        tabIndex={this.props.tabIndex}
        value={this.state.value}
        onChange={this.onChange}
        loadOptions={this.getVehicles}
        valueKey="fake_id"
        labelKey="select_label"
        simpleValue={false}
        defaultOptions={true}
        cacheOptions={true}  
      />
    );
  }
}

SearchInsuredBuildingsField.propTypes = {
  loadPath: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,

  tabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

SearchInsuredBuildingsField = connect((state, props) => ({
  loadPath: `${state.rails.asyncHelpers.searchInsuredBuildings}?member_number=${state.rails.memberNumber}`,
}))(SearchInsuredBuildingsField);

export default SearchInsuredBuildingsField;
